function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from "react";
import styled from "styled-components";
import useDebounce from "react-use/lib/useDebounce";
import { useRect } from "./state/rect";
import { useSize } from "./state/size";
import { useOffset } from "./state/offset";
import { setScope, useScope } from "./state/scope";
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1n05xfq-0"
})(["position:absolute;top:0;left:0;height:100%;"]);
const Scope = /*#__PURE__*/memo(({
  value,
  ...props
}) => {
  const size = useSize();
  const offset = useOffset();
  const {
    width
  } = useRect();
  const {
    end,
    start
  } = useScope();
  const style = {
    width: Math.round((end - start) / size * width),
    transform: `translate3d(${Math.round((start - offset) / size * width)}px, 0, 0)`
  };
  useDebounce(() => {
    const spill = (size * value - size) / 2;
    setScope({
      size,
      offset,
      start: offset - spill,
      end: offset + size + spill
    });
  }, 100, [offset, size, value]);
  return /*#__PURE__*/React.createElement(Root, _extends({
    style: style
  }, props));
});
Scope.defaultProps = {
  value: 2
};
export default Scope;
//# sourceMappingURL=Scope.js.map